// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4QOID","tabsBox":"styles_tabsBox__IF3Le","createButton":"styles_createButton__2HDF2"};